/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Listen_In_WalkInputs */

const en_homepage_listen_in_walk = /** @type {(inputs: Homepage_Listen_In_WalkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`While On A Walk`)
};

const es_homepage_listen_in_walk = /** @type {(inputs: Homepage_Listen_In_WalkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caminando`)
};

/**
* | output |
* | --- |
* | "While On A Walk" |
*
* @param {Homepage_Listen_In_WalkInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_listen_in_walk = /** @type {((inputs?: Homepage_Listen_In_WalkInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Listen_In_WalkInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_listen_in_walk(inputs)
	return en_homepage_listen_in_walk(inputs)
});